import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[preventEmptyFormatter]'
})
export class PreventEmptyFormatterDirective {

    protected el: HTMLElement;

    protected get input(): HTMLInputElement {
        return this.el.getElementsByTagName("input")[0];
    }

    constructor(public formControl: NgControl) {}
    
    @HostListener('blur') 
    onBlur() {
      if(this.formControl.control?.value as string)
        this.formControl.control?.patchValue((<string>this.formControl.control.value).trim())
    }
}
